import { date } from '@/_shared/utils';

export const useMenuTimers = {
  data() {
    return {
      titleTime: '',
      totalDuration: '00:00:00',
      durationTimerId: null,
    };
  },
  methods: {
    observeTitleTime() {
      const _setTime = () => {
        const options = { hour: '2-digit', minute: '2-digit' };
        const currentTime = new Date().toLocaleTimeString([], options);
        this.titleTime = currentTime;
      };
      _setTime();
      setInterval(_setTime, 30000);
    },
    observeTotalDuration() {
      const initTime = date.getDiffBetweenTwoDates(this.startDate, this.endDate);
      const initDate = new Date(`1970-01-01 ${initTime}`);
      const _setTime = () => {
        initDate.setSeconds(initDate.getSeconds() + 1);
        this.totalDuration = initDate.toLocaleTimeString();
      };
      _setTime();
      if (this.endTime === null) {
        this.durationTimerId = setInterval(_setTime, 1000);
      }
    },
    unobserveTotalDuration() {
      if (this.durationTimerId) {
        clearInterval(this.durationTimerId);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/work-shift-menu/useMenuTimers.js